// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__nWqPW","code":"error_code__TBmz6","h1":"error_h1__XZbcd"};